export const ResourceEntityType = Object.freeze({
	Calendar: 'calendar',
	Sku: 'sku',
});
